import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import * as api from '@src/utils/mmc-api/api.js';
import { navigate } from 'gatsby';

const QuestionBankGuard = () => {
  const {
    data: subscribed,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['question-bank-subscription'],
    queryFn: api.questionBankMe,
    refetchInterval: 1000 * 60 * 2,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    // Don't redirect if loading, has data, or if there's an error
    if (isLoading || subscribed || isError) {
      return;
    }

    // Only redirect if we explicitly received false/null (not undefined)
    if (subscribed === false || subscribed === null) {
      navigate('/subscriptions');
    }
  }, [subscribed, isLoading, isError]);

  return null;
};

export default QuestionBankGuard;
